import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Badge, Stat } from '../components/UI';

export default function BuyerDashboard() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getMyOffers()
      .then(setOffers)
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const active = offers.filter(o => o.status === 'active').length;
  const won = offers.filter(o => o.status === 'won').length;
  const outbid = offers.filter(o => o.status === 'outbid' || o.status === 'lost').length;

  return (
    <div style={{ padding: 32, maxWidth: 1100, margin: '0 auto' }}>
      <h2 style={{ fontSize: 28, fontWeight: 800, color: 'var(--text)', fontFamily: 'var(--sans)', letterSpacing: '-0.02em', marginBottom: 8 }}>My Offers</h2>
      <p style={{ fontSize: 14, color: 'var(--text3)', marginBottom: 32 }}>Track your active bids and purchasing activity.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 32 }}>
        <Stat label="Total Offers" value={offers.length} color="var(--text)" />
        <Stat label="Active (Highest)" value={active} color="var(--accent)" />
        <Stat label="Won" value={won} color="var(--blue)" />
        <Stat label="Outbid / Lost" value={outbid} color="var(--red)" />
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 24px', borderBottom: '1px solid var(--border)', fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>Offer History</div>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)' }}>Loading...</div>
        ) : offers.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)' }}>No offers yet. Browse the marketplace to get started.</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--sans)', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)' }}>
                  {['Listing', 'My Offer', 'Status', 'Date'].map(h => (
                    <th key={h} style={{ padding: '12px 24px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontFamily: 'var(--mono)', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 500 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {offers.map(o => (
                  <tr key={o.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '16px 24px', color: 'var(--text)', fontWeight: 500 }}>{o.listing?.title || o.listingId}</td>
                    <td style={{ padding: '16px 24px', fontFamily: 'var(--mono)', color: 'var(--accent)' }}>${Number(o.amount).toLocaleString()}</td>
                    <td style={{ padding: '16px 24px' }}>
                      <Badge color={o.status === 'active' ? 'green' : o.status === 'won' ? 'blue' : 'red'} small>
                        {o.status.toUpperCase()}
                      </Badge>
                    </td>
                    <td style={{ padding: '16px 24px', fontFamily: 'var(--mono)', color: 'var(--text3)', fontSize: 12 }}>
                      {new Date(o.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div style={{
        marginTop: 24, background: 'var(--amber-dim)', border: '1px solid rgba(245,158,11,0.2)',
        borderRadius: 'var(--radius)', padding: '16px 20px', display: 'flex', gap: 12, alignItems: 'flex-start',
      }}>
        <span style={{ fontSize: 18 }}>⚠️</span>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--amber)', marginBottom: 4 }}>Payment Policy</div>
          <div style={{ fontSize: 12, color: 'var(--text2)', fontFamily: 'var(--mono)', lineHeight: 1.6 }}>
            Winning bidders must submit payment within 3 business days of notification. Failure to pay may result in suspension of buyer privileges. Shipping details will be provided after payment confirmation.
          </div>
        </div>
      </div>
    </div>
  );
}
